export const SELECT_USE_CASE = "SELECT_USE_CASE";
export const SET_ALL_USE_CASES = "SET_ALL_USE_CASES";
export const ADD_QUESTION_TO_USE_CASE = "ADD_QUESTION_TO_USE_CASE";
export const OPEN_DELETE_MODAL = "OPEN_DELETE_MODAL";
export const CLOSE_DELETE_MODAL = "CLOSE_DELETE_MODAL";
export const INFINTIE_USECASES = "INFINTIE_USECASES";
export const SET_SEARCHED_USECASES = "SET_SEARCHED_USECASES";
